import { applyFavicon } from 'mini-favicon';
import { getBootstrapOptions } from '../optionsRegistry';
import { getCurrentModule } from 'mini-app-module-store/lib/selectors/getCurrentModule';
import { getModuleBasePath } from 'mini-app-module-store/lib/selectors/getModuleBasePath';
import { getModuleFromPath } from '../utils/getModuleFromPath';
import { getPackageBaseUrl } from 'owa-config';
import { type Module } from 'mini-common-schema';
import { onModuleClick } from 'mini-module-switcher';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';
import { useEffect, useState } from 'react';

export const useHandleModuleChange = (): Module | null => {
    const currentModuleFromStore = getCurrentModule() || 0;
    const [currentModule, setCurrentModule] = useState<Module | null>(null);

    useEffect(() => {
        const moduleFromPath = getModuleFromPath();
        const currentModulePath = `${getModuleBasePath(currentModuleFromStore)}${location.search}`;
        if (moduleFromPath === null) {
            history.replaceState(null, '', currentModulePath);
        } else if (currentModuleFromStore !== moduleFromPath) {
            history.pushState(null, '', currentModulePath);
        }
        setCurrentModule(currentModuleFromStore);
    }, [currentModuleFromStore]);

    useEffect(() => {
        const changeModule = () => {
            const newModule = getModuleFromPath();
            if (currentModule !== newModule) {
                onModuleClick(newModule, currentModule);
            }
        };
        addEventListener('popstate', changeModule);

        return () => {
            removeEventListener('popstate', changeModule);
        };
    }, [currentModule]);

    useEffect(() => {
        if (currentModule !== null) {
            // update the favicon
            const { overrideFavIcon } = getBootstrapOptions(currentModule).appModuleProps;
            applyFavicon(urlResolve(getPackageBaseUrl(), overrideFavIcon));
        }
    }, [currentModule]);

    return currentModule;
};
